import React, { useMemo, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import "./blog-form-page.css"; // styles below

const API_BASE = "https://api.ainfotech.com.np";

export default function BlogForm({ initial, onSaved, onCancel }) {
  const editor = useRef(null);
  const [title, setTitle] = useState(initial?.title || "");
  const [tag1, setTag1] = useState(initial?.tag_primary || "");
  const [tag2, setTag2] = useState(initial?.tag_secondary || "");
  const [excerpt, setExcerpt] = useState(initial?.excerpt || "");
  const [status, setStatus] = useState(initial?.status || "draft");
  const [publishedAt, setPublishedAt] = useState(initial?.published_at?.slice?.(0, 10) || "");
  const [content, setContent] = useState(initial?.content_html || "");
  const [cover, setCover] = useState(null);
  const [saving, setSaving] = useState(false);

  const config = useMemo(
    () => ({ readonly: false, height: 320, uploader: { insertImageAsBase64URI: true } }),
    []
  );

  const submit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("title", title);
    fd.append("tag_primary", tag1);
    fd.append("tag_secondary", tag2);
    fd.append("excerpt", excerpt);
    fd.append("status", status);
    if (publishedAt) fd.append("published_at", publishedAt);
    fd.append("content_html", content);
    if (cover) fd.append("cover_image", cover);

    try {
      setSaving(true);
      const url = initial?.id ? `${API_BASE}/api/blog/${initial.id}` : `${API_BASE}/api/blog`;
      const method = initial?.id ? "PUT" : "POST";
      const res = await fetch(url, { method, credentials: "include", body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Save failed");
      onSaved?.();
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="blog-form-page minimalist">
      {/* LEFT */}
      <section className="bf-left">
        <div className="card">
          <label className="f">
            <span className="f__label">Post Title</span>
            <input
              className="f__input"
              placeholder="Enter post title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </label>
        </div>

        <div className="card">
          <label className="f">
            <span className="f__label">Card Description (Excerpt)</span>
            <textarea
              className="f__textarea"
              rows="4"
              value={excerpt}
              onChange={(e) => setExcerpt(e.target.value)}
              placeholder="Short summary shown in cards…"
            />
          </label>

          <div className="row row--gap">
            <label className="f grow">
              <span className="f__label">Tag (Primary)</span>
              <input
                className="f__input"
                value={tag1}
                onChange={(e) => setTag1(e.target.value)}
                placeholder="e.g. News"
              />
            </label>
            <label className="f grow">
              <span className="f__label">Tag (Secondary)</span>
              <input
                className="f__input"
                value={tag2}
                onChange={(e) => setTag2(e.target.value)}
                placeholder="e.g. Update"
              />
            </label>
          </div>
        </div>

        <div className="card">
          <div className="card__title">Cover Image</div>
          <input
            className="f__input"
            type="file"
            accept="image/*"
            onChange={(e) => setCover(e.target.files?.[0] || null)}
          />
        </div>

        <div className="card">
          <div className="card__title">Content</div>
          <div className="editor">
            <JoditEditor ref={editor} value={content} config={config} onChange={(val) => setContent(val)} />
          </div>
        </div>
      </section>

      {/* RIGHT */}
      <aside className="bf-right">
        <div className="card slim">
          <div className="card__title">Publish</div>

          <label className="f">
            <span className="f__label">Status</span>
            <select className="f__input" value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="draft">draft</option>
              <option value="published">published</option>
            </select>
          </label>

          <label className="f">
            <span className="f__label">Publish Date</span>
            <input
              className="f__input"
              type="date"
              value={publishedAt}
              onChange={(e) => setPublishedAt(e.target.value)}
            />
          </label>

          <div className="row end gap">
            <button type="button" className="btn btn--sm" onClick={onCancel}>
              Cancel
            </button>
            <button disabled={saving} className="btn primary">
              {saving ? "Saving..." : "Save Post"}
            </button>
          </div>
        </div>
      </aside>
    </form>
  );
}
